module.exports = __webpack_public_path__ + "static/media/mrTodo.4e40eb3f.webp";